export const UPDATE_NOTIFICATION = 'UPDATE_NOTIFICATION';
export const SET_NOTIFICATION = 'SET_NOTIFICATION';


export function updateNotification(data) {
	return dispatch => {
		dispatch({
			type: UPDATE_NOTIFICATION,
			data,
		});
	}
}

export function setNotification(data) {
	return dispatch => {
		dispatch({
			type: SET_NOTIFICATION,
			data
		});
	}
}